import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import s from './Header.css';
import Link from '../Link';
import Navigation from '../Navigation';
import ImpersonationBar from '../ImpersonationBar';

/**
 * Шапка (лого + меню). Прилипает к верху и слегка просвечивает,
 * как панели в окне настроек расширения.
 * @returns {*}
 * @constructor
 */
export default function Header() {
	useStyles(s);

	return (
		<header className={s.root}>
			{/* Пока админ смотрит сайт как пользователь — плашка с возвратом */}
			<ImpersonationBar />
			<div className={s.inner}>
				<Link className={s.brand} to="/">
					<img
						src="/logo.png"
						width={165}
						height={70}
						alt="New Tab Studio"
					/>
				</Link>

				<div className={s.nav}>
					<Navigation />
				</div>
			</div>
		</header>
	);
}
